import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ErrorAlert from 'Components/ComponentLibrary/Atoms/Alerts/Basic';
import { dataAttrs } from 'Helpers/Testing';
import { useMaybeMetaLayoutContext } from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const styles = () => ({
  root: {},
  rootHidden: {
    display: 'none',
  },
  alert: {},
});

const ErrorList = ({
  className,
  classes,
  errors,
}) => {
  const { resource } = useMaybeMetaLayoutContext() ?? {};
  return (
    <Box
      className={classNames(classes.root, className, {
        [classes.rootHidden]: errors.length === 0,
      })}
      {...dataAttrs('error-list', resource)}
    >
      {errors.map((err) => {
        const title = err.title || null;
        const message = err.detail || err.shortDetail;

        return (
          <ErrorAlert
            className={classes.alert}
            title={title}
            message={message}
            severity={'error'}
          />
        );
      })}
    </Box>
  );
};

ErrorList.defaultProps = {
  className: '',
  errors: [],
};

ErrorList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  errors: PropTypes.array,
};

export default withStyles(styles)(ErrorList);
